import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#each this.icons as |icon|}}
  {{d-icon icon translatedTitle=this.dasherizedTitle}}
{{/each}}

<span class="name">
  {{this.label}}
</span>
*/
{
  "id": "4ip9dIrO",
  "block": "[[[42,[28,[37,1],[[28,[37,1],[[30,0,[\"icons\"]]],null]],null],null,[[[1,\"  \"],[1,[28,[35,2],[[30,1]],[[\"translatedTitle\"],[[30,0,[\"dasherizedTitle\"]]]]]],[1,\"\\n\"]],[1]],null],[1,\"\\n\"],[10,1],[14,0,\"name\"],[12],[1,\"\\n  \"],[1,[30,0,[\"label\"]]],[1,\"\\n\"],[13]],[\"icon\"],false,[\"each\",\"-track-array\",\"d-icon\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/select-kit/select-kit-none-row.hbs",
  "isStrictMode": false
});